import {
	ADD_SAMPLE,
	REMOVE_SAMPLE,
	CLEAR_SAMPLES,
	UPDATE_SAMPLE_CART,
	REMOVE_POST,
} from '../types/sampleCart';

export const addSample = (id) => {
	return {
		type: ADD_SAMPLE,
		id,
	};
};

export const removeSample = (id) => {
	return {
		type: REMOVE_SAMPLE,
		id,
	};
};

export const clearSample = () => {
	return {
		type: CLEAR_SAMPLES,
	};
};

export const updateSampleCart =(samples) => {
	return {
		type: UPDATE_SAMPLE_CART,
		samples,
	};
};

export const removePOST = (id) => {
	return {
		type: REMOVE_POST,
		id,
	}
}
